module.exports = __webpack_public_path__ + "img/home-page.1836d013.jpg";